import { css } from "styled-components/macro";
import { useIsAdmin, useFocusRange } from "utils/customHooks/genericHooks";
import { useIsMidgardDDAEnabled } from "components/Dashboard/GroupMetrics/useMetrics";
import { ONE_DAY_OF_MS } from "utils/timeUtils";
import { Close, Warning } from "@mui/icons-material";
import { NotificationCard } from "components/SimpleComponents/TopBanner/NotificationCard";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";
import { IconButton } from "@mui/material";
import { useState } from "react";

export function DashboardPagesMisconfiguredWarning() {
  const isAdminUser = useIsAdmin();
  return isAdminUser ? <DashboardPagesMisconfiguredWarningContent /> : null;
}

function DashboardPagesMisconfiguredWarningContent() {
  const focusRange = useFocusRange();
  const [
    {
      general: { overrideDdaLimitDays },
    },
  ] = useFlightConfig();
  const isMidgardDDAEnabled = useIsMidgardDDAEnabled();
  const dateRangeDays = focusRange
    ? Math.ceil(focusRange.lt - focusRange.ge) / ONE_DAY_OF_MS
    : 0;
  const limit = overrideDdaLimitDays || 1;
  const isAboveMidgardDDALimit = dateRangeDays > limit;
  const [dismissed, setDismissed] = useState(false);
  const showWarning =
    isMidgardDDAEnabled && isAboveMidgardDDALimit && !dismissed;
  return showWarning ? (
    <NotificationCard
      message={
        <div>
          <div>
            {`Dashboard page is misconfigured — requested date range (${dateRangeDays} day${
              dateRangeDays === 1 ? "" : "s"
            }) is larger than the current limit (${limit} day${
              limit === 1 ? "" : "s"
            }).`}
          </div>
          <div>
            <>
              Either{" "}
              <a
                href="https://app.launchdarkly.com/default/production/features/flight-override-is-midgard-enabled/targeting"
                target="_blank"
                rel="noreferrer"
              >
                disable Midgard
              </a>{" "}
              or{" "}
              <a
                href={`https://app.launchdarkly.com/projects/default/flags/flight-config-overrides-from-ld/targeting?env=production&selected-env=production`}
                target="_blank"
                rel="noreferrer"
              >
                increase the limit
              </a>
              .
            </>
            <IconButton
              onClick={() => {
                setDismissed(true);
              }}
              size="small"
              style={{ position: "absolute", right: 0, top: 0 }}
            >
              <Close />
            </IconButton>
          </div>
        </div>
      }
      icon={<Warning style={{ opacity: 0.6, width: 30, height: 30 }} />}
      variant={"warning"}
      customCss={css`
        margin: 12px 12px 0;
      `}
    />
  ) : null;
}
